import styled from '@styled';
import {
  color_grey_17,
  color_white,
  color_yellow_FB,
  color_blue_ss,
  color_blue_bt,
  font_montserrat,
  tabletPortrait,
} from '../../../styles/generic/global.styles';

interface AProps {
  variant?: 'primary' | 'secondary' | 'white' | 'purple' | 'green' | 'blue';
  width?: string;
  padding?: string;
  margin?: string;
  display?: string;
  whiteSpace?: string;
  mobileWidth?: string;
  mobileDisplay?: string;
  fontFamily?: string;
  backgroundColor?: string;
  textColor?: string;
}

export const StyledAButton = styled('a').withConfig({
  shouldForwardProp: (prop) =>
    !['whiteSpace', 'mobileWidth', 'mobileDisplay', 'fontFamily', 'backgroundColor', 'mobileMargin', 'textColor'].includes(prop),
})<AProps>`
  background-color: ${(props) => {
    if (props.backgroundColor) {
      return props.backgroundColor;
    } else {
      switch (props['data-variant']) {
        case 'primary':
          return `${color_yellow_FB}`;
        case 'secondary':
          return `${color_blue_ss}`;
        case 'white':
          return `#F5F6F7`;
        case 'purple':
          return `#5F2781`;
        case 'green':
          return `#006361`;
        case 'blue':
          return `#1e8bc2`;
      }
    }
  }};
  color: ${(props) => {
    if (props.textColor) {
      return props.textColor;
    } else {
      switch (props['data-variant']) {
        case 'primary':
          return `${color_grey_17}`;
        case 'secondary':
          return `${color_white}`;
        case 'white':
          return `${color_blue_bt}`;
        case 'purple':
          return `#FFF`;
        case 'green':
          return `${color_white}`;
        case 'blue':
          return `${color_white}`;
      }
    }
  }};
  padding: ${(props) => props.padding || '17px 27px'};
  display: ${(props) => props.display || 'initial'};
  border: none;
  font-size: 18px;
  font-weight: 700;
  border-radius: 14px;
  text-align: center;
  text-decoration: none;
  white-space: ${(props) => props.whiteSpace || 'nowrap'};
  width: ${(props) => props.width || 'fit-content'};
  margin: ${(props) => props['data-margin'] || '0'};
  font-family: ${(props) => props.fontFamily || font_montserrat};

  img {
    margin-right: 10px;
  }

  ${tabletPortrait} {
    width: ${(props) => props.mobileWidth || props.width || 'fit-content'};
    display: ${(props) => props.mobileDisplay || props.display || 'initial'};
    margin: ${(props) => props.mobileMargin || props['data-margin'] || '0'};
  }
`;
